import React from 'react';
import { InfoIcon } from '../../assets/common_svgs';

const TabTextbox = ({ children, className, showIcon, showSeparator }) => (
  <div
    className={`quick-orders-tab_textbox ${className} width-100 ${
      showSeparator ? 'quick-orders__separator' : ''
    }`}>
    <div className="p-14 fl fl-row">
      <div className="tabtextbox__icon fl jc-c">
        {showIcon && (
          <InfoIcon fillColor="#7E7E7E" cn="quick-order__info-icon" />
        )}
      </div>
      <div className="tabtextbox__content grey-70 body-font pl-10 nm">
        {children}
      </div>
    </div>
  </div>
);

export default TabTextbox;
